import { ProcedureSigtapStruct } from "../../structs/billing/procedure-sigtap.struct";

export class ProcedureSigtapRequest
{
    public dateCompetence: string;

    public observation: string;

    public procedureSigtapStruct: ProcedureSigtapStruct[];
}